import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const pushEndpointHost = () => {
    const { config } = firebase;
    const settings = store.getState().settingsdata.settings;
    return typeof window !== 'undefined' && window.location && settings && settings.CompanyWebsite === window.location.origin
        ? window.location.origin
        : `https://${config.projectId}.web.app`;
};

export const pushAuthHeaders = async () => {
    const headers = { 'Content-Type': 'application/json' };
    try {
        const currentUser = firebase.auth && firebase.auth.currentUser;
        if (currentUser) {
            headers.Authorization = `Bearer ${await currentUser.getIdToken()}`;
        }
    } catch (error) {
        console.log(error);
    }
    return headers;
};

/**
 * `toUid` es el usuario destinatario: el servidor usa su token vigente, así la notificación llega
 * al dispositivo actual aunque el token guardado en la reserva esté desactualizado.
 */
export const RequestPushMsg = async (token, data, toUid) => {
    if (!token && !toUid) return;
    try {
        const response = await fetch(`${pushEndpointHost()}/send_notification`, {
            method: 'POST',
            headers: await pushAuthHeaders(),
            body: JSON.stringify({
                ...data,
                token: token || null,
                toUid: toUid || null,
            })
        });
        return await response.json().catch(() => null);
    } catch (error) {
        console.log(error);
    }
}
